import styled from "styled-components";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_SEARCH } from "common/constants";
import React from "react";
import { SubGroupContactInfo } from "@shared/types";
import { getNewLookTokens, NEW_LOOK_RADIUS } from "common/NewLook/tokens.ts";

interface ContactInfoProps {
  contactInfo: SubGroupContactInfo;
}

const ContactInfo = ({ contactInfo }: ContactInfoProps) => {
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);

  return (
    <ContactInfoWrapper>
      {Object.entries(contactInfo).map(
        ([_socialMedia, SocialMediaInfo], index) => (
          <Link
            key={index}
            href={SocialMediaInfo.link}
            target="_blank"
            $isMobile={isMobile}
          >
            <Logo src={SocialMediaInfo.image_link} $isMobile={isMobile} />
          </Link>
        )
      )}
    </ContactInfoWrapper>
  );
};

export default ContactInfo;

const ContactInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 16px;
  row-gap: 16px;
  ${(p) => p.theme.isNewLook && `column-gap: 8px; row-gap: 8px;`}
`;
const Logo = styled.img<{ $isMobile: boolean }>`
  position: relative;
  height: auto;
  width: 20px;
  ${(p) =>
    p.theme.isDarkMode &&
    `
    filter: Brightness(140%);
  `};
`;
const Link = styled.a<{ $isMobile: boolean }>`
  border-radius: 50%;
  background: ${(p) => p.theme.colors.lightBlue};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  ${(p) =>
    p.theme.isNewLook &&
    `
    width: 36px;
    height: 36px;
    border-radius: ${NEW_LOOK_RADIUS.control}px;
    background: ${getNewLookTokens(p.theme).panel};
    border: 1px solid ${getNewLookTokens(p.theme).hairlineStrong};
    transition: border-color 120ms, background-color 120ms;
    &:hover {
      border-color: ${getNewLookTokens(p.theme).accent};
      background: ${getNewLookTokens(p.theme).rowHover};
    }
    &:focus-visible {
      outline: 2px solid ${getNewLookTokens(p.theme).focus};
      outline-offset: 1px;
    }
  `}
`;
